const useAddEnquiry = () => {
  const ENQUIRY_LIST_STORAGE = 'ENQUIRY_LIST_STORAGE';
  const addEnquiryListStorage = (data) => {
    window.localStorage.setItem(ENQUIRY_LIST_STORAGE, JSON.stringify(data));
  };
  const getEnquiryListStorage = () => {
    const data = window.localStorage.getItem(ENQUIRY_LIST_STORAGE);
    if (!data) return [];
    return JSON.parse(data);
  };
  const removeEnquiryListStorage = () => {
    window.localStorage.removeItem(ENQUIRY_LIST_STORAGE);
  };
  return {
    addEnquiryListStorage,
    getEnquiryListStorage,
    removeEnquiryListStorage,
    ENQUIRY_LIST_STORAGE,
  };
};
export default useAddEnquiry;
